import { render, staticRenderFns } from "./work-order-material-availability-status.vue?vue&type=template&id=0d3b4b78&scoped=true&"
import script from "./work-order-material-availability-status.vue?vue&type=script&lang=js&"
export * from "./work-order-material-availability-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3b4b78",
  null
  
)

export default component.exports